import useSWR from "swr";
import { type CategoryType } from "../../api/types";
import { simpleFetcher } from "../fetcher";

const url = "/api/v2/categories";

export function useCategories(query?: URLSearchParams) {
  const key = query ? `${url}?${query.toString()}` : url;
  const { data, error, mutate } = useSWR<CategoryType[], Error>(
    key,
    simpleFetcher,
    {
      revalidateOnFocus: false,
      revalidateIfStale: false,
    },
  );
  return {
    data,
    error,
    mutate,
    isLoading: !error && !data,
  };
}
